export const cardsRoutes = {
  GET_CARDS: "/cards", // GET (новый API)
  GET_CARD_BY_ID: (id: number) => `/cards/${id}`, // GET (новый API)
  CREATE_CARD: "/cards", // POST (новый API)
  UPDATE_CARD: (id: number) => `/cards/${id}`, // PUT (новый API)
  DELETE_CARD: (id: number) => `/cards/${id}`, // DELETE (новый API)
  // Старый эндпоинт для получения токена (для обратной совместимости)
  GET_TOKEN: "api/profile/addCard", // GET (старый API)

  // Т-Касса: карты хранит сам банк (Rebill), поэтому не наша таблица cards,
  // а прокси к Т-Кассе. Список отдаётся в том же виде {id, token, title}.
  TINKOFF_CARDS: "/payments/cards/tinkoff", // GET — список, POST — старт привязки
  TINKOFF_CARD_STATE: (requestKey: string) => `/payments/cards/tinkoff/state/${requestKey}`, // GET
  TINKOFF_DELETE_CARD: (cardId: number | string) => `/payments/cards/tinkoff/${cardId}`, // DELETE
};
